import { render, staticRenderFns } from "./ExternalAccountPage.vue?vue&type=template&id=0d3ed5f1&"
import script from "./ExternalAccountPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalAccountPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports